module.exports = __webpack_public_path__ + "static/media/image12.99ced9b3.jpg";